<template>
  <section class="app-home">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-card outlined class="card-search">
            <v-card-text>
              <!-- <h2 class="titlemain">Bem Vindos!</h2> -->
              <h3 class="subtitle">
                Ultilize a pesquisa abaixo ou a barra lateral para encontrar o
                serviço desejado
              </h3>
              <v-form class="app-form-search">
                <v-text-field
                  type="text"
                  label
                  placeholder="Digite o serviço que está procurando"
                  v-model="form.term"
                  filled
                  rounded
                  dense
                  append-icon="search"
                  :loading="isLoading"
                  @input="searchService"
                ></v-text-field>
              </v-form>
            </v-card-text>
          </v-card>
          <services-list
            :data="servicesFiltered"
            v-if="servicesFiltered && servicesFiltered.length > 0"
          ></services-list>
          <p class="notfound" v-else>
            Não encontramos nenhum serviço para o termo pesquisado "{{
              form.term
            }}".
          </p>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import ServicesList from "@/components/ServicesList.vue";
import { services } from "@/models/service";
import { Subject, of } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  tap,
  switchMap
} from "rxjs/operators";

export default {
  components: {
    ServicesList
  },
  data() {
    return {
      servicesFiltered: services,
      form: { term: null },
      isLoading: false,
      subjectService: null
    };
  },
  mounted() {
    this.serviceSubject();
  },
  methods: {
    searchService(value) {
      //const { value } = event.target;
      this.subjectService.next(value);
    },
    serviceSubject() {
      this.subjectService = new Subject();
      this.subjectService
        .pipe(
          tap(value => {
            this.isLoading = true;
          })
        )
        .pipe(debounceTime(1000))
        .pipe(distinctUntilChanged())
        .pipe(
          switchMap(value => {
            if (!value) {
              return of(services);
            }

            return of(
              services
                .map(s => {
                  const { name, url } = s;
                  let list = s.list.filter(l =>
                    l.name.toLowerCase().includes(value.toLowerCase())
                  );
                  const service = { name, url, list };
                  return service;
                })
                .filter(service => service.list.length > 0)
            );
          })
        )
        .subscribe(
          result => {
            this.servicesFiltered = result;
            this.isLoading = false;
          },
          error => {
            this.isLoading = false;
          }
        );
    }
  }
};
</script>

<style lang="scss" scoped>
.titlemain {
  font-size: 22px !important;
  margin-bottom: 12px;
  margin-top: 10px;
  font-weight: 400 !important;
  line-height: 22px !important;
}
.subtitle {
  font-size: 16px !important;
  margin-top: 0px;
  color: #58595b;
}
.notfound {
  padding: 10px 0px;
  text-align: center;
  font-size: 15px !important;
}
.card-search {
  border-bottom: solid;
  border-bottom-width: 3px !important;
  border-bottom-color: #2e70b6 !important;
}
.app {
  &-form-search {
    margin-top: 20px;
    position: relative;
  }
}
</style>
